import { CheckBox, DateBox, TextBox } from "devextreme-react";
import { useAtomValue } from "jotai";
import { hcostInboundAtom } from "@/store/hcost-atom";
import { CommonConst } from "@constants/common-const";
import useCounselHook from "@feature/counsel/useCounselHook";

type Props = {
  accessType: string;
};

const CounselSystemInfo = ({ accessType }: Props) => {
  const hCostResult = useAtomValue(hcostInboundAtom);
  const { onValueChangeCounselHandler } = useCounselHook();

  return (
    <>
      {/*시스템 정보*/}
      <div className="content-fieldset">
        <h3 className="content-fieldset-title">시스템 정보</h3>
        <div className="content-fieldset-title-desc" />
        {accessType === CommonConst.ACCESS_TYPE_ADMIN && (
          <>
            <div className="content-field row">
              <div className="content-field-label">
                <div className="content-label-name">생성 조직</div>
                <div className="content-label-desc" />
              </div>
              <div className="content-field-value full">
                <TextBox value={hCostResult.conSourceCompany?.companyName} readOnly={true} />
                <div className="content-value-desc" />
              </div>
            </div>
          </>
        )}
        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name">등록 일시</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <DateBox
              readOnly={true}
              value={hCostResult.createDate}
              displayFormat="yyyy-MM-dd a hh:mm:ss"
              type="datetime"
            />
            <div className="content-value-desc" />
          </div>
        </div>
        <div className="content-field row">
          <div className="content-field-label">
            <div className="content-label-name">수정 일시</div>
            <div className="content-label-desc" />
          </div>
          <div className="content-field-value full">
            <DateBox
              readOnly={true}
              value={hCostResult.lastUpdate}
              displayFormat="yyyy-MM-dd a hh:mm:ss"
              type="datetime"
            />
            <div className="content-value-desc" />
          </div>
        </div>
        {accessType === CommonConst.ACCESS_TYPE_ADMIN && (
          <div className="content-field row">
            <div className="content-field-label">
              <div className="content-label-name">고객 IP</div>
              <div className="content-label-desc" />
            </div>
            <div className="content-field-value full">
              <TextBox value={hCostResult.customerIp} readOnly={true} />
              <div className="content-value-desc" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CounselSystemInfo;
